import React, {useEffect, useId} from 'react';
import './custom_confirm.scss';

const CustomConfirm = (props) => {
  const url = props.url;
  const requestMethod = props.request_method;
  const {message, content, title = ''} = props;
  const randomId = useId();

  useEffect(() => {
    document.getElementById(randomId).innerHTML = content;
    document.getElementById(randomId).addEventListener('click', () => {
      Confirm.open({
        message: message,
        title: title,
        onok: () => {}
      })
    });
  }, [])

  const Confirm = {
    open (options) {
      options = Object.assign({}, {
        message: '',
        okText: 'Yes',
        cancelText: 'Cancel',
        title: '',
        onok: function () {},
        oncancel: function () {}
      }, options);

      const html = `
            <div class="confirm">
                <div class="confirm__window">
                    <div class="confirm__titlebar">
                        <button class="confirm__close">&times;</button>
                    </div>
                    <div class="confirm__content"><p class="text-xl -mb-16">${options.message}</p></div>
                    <div class="confirm__content"><p class="text-base text-darkgray text-center w-10/12">${options.title}</p></div>
                    <div class="confirm__buttons">
                        <a rel="nofollow" data-method="${requestMethod}" href="${url}" class="confirm__button confirm__button--ok confirm__button--fill mr-8 hover:text-white"><p class="ml-12">${options.okText}</p></a>
                        <button class="confirm__button confirm__button--cancel "><p>${options.cancelText}</p></button>
                    </div>
                </div>
            </div>
        `;

      const template = document.createElement('template');
      template.innerHTML = html;

      // Elements
      const confirmEl = template.content.querySelector('.confirm');
      const btnClose = template.content.querySelector('.confirm__close');
      const btnOk = template.content.querySelector('.confirm__button--ok');
      const btnCancel = template.content.querySelector('.confirm__button--cancel');

      confirmEl.addEventListener('click', e => {
        if (e.target === confirmEl) {
          options.oncancel();
          this._close(confirmEl);
        }
      });

      btnOk.addEventListener('click', () => {
        options.onok();
        this._close(confirmEl);
      });

      [btnCancel, btnClose].forEach(el => {
        el.addEventListener('click', () => {
          options.oncancel();
          this._close(confirmEl);
        });
      });

      document.body.appendChild(template.content);
    },

    _close (confirmEl) {
      confirmEl.classList.add('confirm--close');

      confirmEl.addEventListener('animationend', () => {
        document.body.removeChild(confirmEl);
      });
    }
  };

  return (
    <div>
      <button id={randomId}></button>
    </div>
  );
};

export default CustomConfirm;
